// Adapted from https://stackoverflow.com/a/45905238

export const downloadFile = (name: string, dataUrl: string) => {
    const link = document.createElement('a');
    link.download = name;
    link.href = dataUrl;
    link.click();
};
